import React, { useEffect, useState } from 'react';
import { Button, message, Table, Popconfirm, Space } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import useBreadCrumb from './../hooks/useBreadCrumb';
import { GetData } from '../apiService/GetData';
import { DeleteDataAuth } from '../apiService/DeleteData'; 
import { apis } from '../properties';
import CommitteeMemberModal from './../components/CommitteeManagement/CommitteeMemberModal';

function CommitteeManagementPage() {
    const location = useLocation();
    useBreadCrumb("Committee Management", location.pathname, "Committee");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingMember, setEditingMember] = useState(null);

    const fetchMembers = () => {
        setLoading(true);
        GetData(apis.COMMITTEE_MANAGEMENT)
            .then(data => {
                setMembers(data.data);
                setLoading(false);
            })
            .catch(err => {
                message.error("Failed to fetch committee members");
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchMembers();
    }, []);

    const handleOpenModal = (record = null) => {
        setEditingMember(record);
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setEditingMember(null);
    };

    const handleDelete = async (id) => {
        try {
            await DeleteDataAuth(`${apis.COMMITTEE_MANAGEMENT}/${id}`);
            message.success("Role removed successfully");
            fetchMembers();
        } catch (error) {
            message.error("Failed to delete role");
        }
    };

    const columns = [
        {
            title: 'Roles',
            dataIndex: 'role_name',
            key: 'role',
            render: (text) => <strong>{text}</strong>,
        },
        {
            title: 'Member Name',
            render: (_, record) => {
            const member = record.member_id;
            return member ? `${member.first_name} ${member.last_name}` : 'N/A';
        },
            key: 'member_name',
        },
        {
            title: 'Hash Name',
            dataIndex: ['member_id', 'hash_name'],
            key: 'hash_name',
        },
        {
            title: 'Actions',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        icon={<EditOutlined />}
                        onClick={() => handleOpenModal(record)}
                    >
                        Update
                    </Button>
                    <Popconfirm
                        title="Are you sure you want to delete this member?"
                        onConfirm={() => handleDelete(record._id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link" danger icon={<DeleteOutlined />}>
                            Delete
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: '40px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h1>Committee Management</h1>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => handleOpenModal(null)}
                >
                    Add Member
                </Button>
            </div>

            <Table
                dataSource={members}
                columns={columns}
                rowKey="_id"
                loading={loading}
                bordered
                pagination={false}
            />

            <CommitteeMemberModal
                visible={isModalOpen}
                onCancel={handleCancel}
                onSubmitSuccess={fetchMembers}
                initialValues={editingMember}
            />
        </div>
    );
}

export default CommitteeManagementPage;